<div>
    <img alt="cibil-logo" src="../../../../assets//images/cibil/powered-by-cibil-logo.png" class="ml-4 mt-4" style="width: 51px; height: 30px;"/>
</div>
<section class="page-wrapper">
    <article class="heading-portion">
        <h3 class="heading-text mt-2">Provide Alternate Number</h3>
        <p class="heading-sub-text red" *ngIf="!alternativeMobileForm.value.mobileNumber">{{data.errorMessage}}</p>
    </article>
    <div class="d-flex justify-content-center mt-3">
        <div class="col-sm-10 col-md-8">
            <form [formGroup]="alternativeMobileForm">
                <div class="row pt-2">
                    <div [class.readonly-input]="disableMobileNumberField">
                        <p class="color_gray" [class.blackLabel]="!alternativeMobileForm.value.mobileNumber">Please
                            Enter Your Mobile Number</p>
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput placeholder="Enter your alternate mobile number" maxlength="10" required
                                formControlName="mobileNumber" type="number"
                                [class.gapLetters]="alternativeMobileForm.value.mobileNumber"
                                onKeyPress="if(this.value.length==10) return false;" [readonly]="disableMobileNumberField">
                            <mat-error>{{getErrorMessage(alternativeMobileForm.controls.mobileNumber)}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="alternativeMobileForm.value.mobileNumber">
                        <p class="color_gray" [class.blackLabel]="!alternativeMobileForm.value.otp">OTP</p>
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput placeholder="Enter your OTP" required formControlName="otp" type="string"
                                [class.gapLetters]="alternativeMobileForm.value.otp" onKeyPress="if(this.value.length==6) return false;">
                            <mat-error>{{getErrorMessage(alternativeMobileForm.controls.otp)}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div *ngIf="resendEnabled" class="d-flex justify-content-center">
        <p class="text-color-darker-grey mt-4 resendOtpText pl-4 pr-4 text">
            Didn’t receive OTP?  <a (click)="OnResendOtpClicked()" style="cursor: pointer">click here</a> to resend OTP, <span class="text-danger font-weight-bold">(1 attempt is left)</span>
        </p>
    </div>
    <div class="d-flex justify-content-center mt-3" *ngIf="data.wrongOtpEntered">
        <p class="text-danger font-weight-bold">
            Entered OTP is wrong, {{data.wrongOtpEntered == 1 ? 2 : data.wrongOtpEntered == 2 ? 1 : 0}} attempt is left
        </p>
    </div>
    <article class="footer mt-5 d-flex">
        <button class="btn-outline mr-md-2" (click)="onBackButtonClicked()">Skip</button>
        <div class="d-flex submitButton">
            <button type="submit" mat-flat-button class="primary" [disabled]="isVerifyButtonDisabled() || isLoading"
                [disableRipple]="true" (click)="onVerifyClicked()">
                <span class="spinner-border spinner-border-sm mr-4" role="status" *ngIf="isLoading"></span>
                {{buttonText}}
            </button>
        </div>
    </article>
</section>